<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="是否分销："> 
                <el-select v-model="searchForm.isSold" clearable>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态："> 
                <el-select v-model="searchForm.cardState" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
              <el-form-item label="专属靓号：">
                <el-input v-model.trim="searchForm.phoneNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号段：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" clearable></el-input>
                </el-col>                
            </el-form-item>

            <el-form-item label="已使用流量(G)："  class="iccid_number_input">
                <el-row style="display:flex;width:400px;">
                    <el-col style="flex:3">
                        <el-select  v-model="searchForm.op" placeholder="请选择">
                            <el-option
                            clearable
                            v-for="item in ops"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="1" class="separate"></el-col>
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="searchForm.usedFlowRate" clearable></el-input-number>
                    </el-col>
                </el-row>                
                
            </el-form-item>
 
            <el-form-item label="ICCID列表：" class="iccid_textarea_range">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                    maxlength="2000"
                    v-model="searchForm.iccidStrs">
                    </el-input>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler">搜索查询</el-button>
                <el-button type="success"  @click="exportHistorySimInfoHandle">导出Excel</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号码" width="130px"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称"></el-table-column>
            <el-table-column prop="alias" label="通道"></el-table-column>
            <el-table-column prop="createTime" label="导入时间"  width="140px"></el-table-column>
            <el-table-column prop="batchNo" label="导入批次" width="80px"></el-table-column>
            <el-table-column prop="basePkgGroupName" label="套餐组"></el-table-column>
            <el-table-column label="总流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.flowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.usedFlowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="剩余流量(G)">
                <template slot-scope="scope">
                    {{ decrease(fluxMtoG(scope.row.flowRate), fluxMtoG(scope.row.usedFlowRate)) }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="cardTypeName" label="卡片类型"  width="80px"></el-table-column> -->
            <el-table-column prop="agentPathNames" label="分销商姓名"></el-table-column>
            <el-table-column prop="cardStateName" label="卡状态"  width="100px"></el-table-column>
            <el-table-column prop="isSoldName" label="分销状态" width="100"></el-table-column>
             <el-table-column label="操作" width="100">
                 <template slot-scope="scope">
                    <el-button  type="text" @click="resumeInfoHandler(scope.row, $event)">恢复</el-button>
                </template>
             </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>   
    </div>
</template>

<script>
import {getAdminCardList,resumeInfo} from '@/api/history_sim.js'
import {getCardStateDict} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                isSold: '',
                cardState: '',
                supplierCode: '',
                basePkgGroup: '',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },            
            simHandleVisibale: false,
            simHandleForm: {
                agentId: ''
            },
            pkgGroup: [],
            branchSupplierOption: [],
            agentListOption: [],
            cardStateOption: [],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            },
            ops:[
                {label:'等于',value:"="},
                {label:'大于',value:">"}
            ]      
        }
    },
    methods: {
        cancel(){
            this.simHandleVisibale = false;    
            this.$refs.simHandleForm.resetFields();  
        },
        getAdminCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if(data.usedFlowRate){
                data.usedFlowRate = data.usedFlowRate * 1024;
            }
            getAdminCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        resumeInfoHandler:function(row,$event){ //恢复
            let self = this;
            resumeInfo(row.id).then(res=>{
                if(res.data.code == 200){
                    this.$message.success('恢复成功');
                    self.goToDetailPage(row);
                }else{
                    this.$message.error(res.data.message);
                }
            }).catch((err)=>console.error(err))
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },        
        exportHistorySimInfoHandle(){//导出excel文件
            let _that = this;
            this.$message.success('即将开发,敬请期待');
            // exportSimInfo(_that.searchForm).then(res =>{
            //     if(res.data.code == 200){
            //         this.$message.success('数据导出中,请稍候去下载专区下载');
            //     }else{
            //         this.$message.error(res.data.msg);
            //     }
            // }).catch(err=>console.error(err));            
        }
    },
    created () {
        // this.getAdminCardListHandler();
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        getCardStateDict({}).then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }    
        })
    }
}
</script>

<style lang="less" scoped>

</style>

